export default {
  SET_STATE: 'topics/SET_STATE',
  FETCH_TOPICS: 'topics/FETCH_TOPICS',
  // FETCH_SINGLE_READER: 'users/readers/FETCH_SINGLE_READER',
  // UPDATE_READER: 'users/readers/UPDATE_READER',
}
